import { type RumInitConfiguration } from "@datadog/browser-rum-core";

export const datadogRumConfig = {
  applicationId: "23c4bce9-dae9-4484-89b8-1f5e436dcc79",
  clientToken: "pub37b0223ac83fed9ac25368c00c0e4901",
  site: "datadoghq.eu",
  service: "inventory",
  env: process.env.MODE,
  // The version is used for source map upload and version tag in the RUM explorer.
  version: process.env.APP_VERSION,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: "allow",
} as RumInitConfiguration;
